
import { about } from '@project/api/about/v1'
import { page as jobPage, jobPost } from '@project/api/careers/v1'
import { page as wellnessCenter } from '@project/api/wellness-center/v1'
import { page as home, common } from '@project/api/home/v1'
import { page as mainCalendar } from '@project/api/main-calendar/v1'
import { page as forms } from '@project/api/forms/v1'
import { page as contactUs } from '@project/api/contact-us/v1'
import { page as housing } from '@project/api/housing/v1'
import { page as history } from '@project/api/history/v1'
import { paginate as paginateAgendas, total as totalAgendas, page as agendasPage } from '@project/api/agendas/v1'
import { paginate as paginateMinutes, total as totalMinutes, page as minutesPage } from '@project/api/minutes/v1'
import { paginate as paginateNews, total as totalNews, page as newsPage, newsStory } from '@project/api/news/v1'


export default {
  async home() {
    return await home()
  },
  async housing() {
    return await housing()
  },
  async history() {
    return await history()
  },
  async contactUs() {
    return await contactUs()
  },
  async common() {
    return await common()
  },
  async about() {
    return await about()
  },
  async forms() {
    return await forms()
  },
  async jobPage() {
    return await jobPage()
  },
  async jobPost(id) {
    return await jobPost(id)
  },
  async wellnessCenter() {
    return await wellnessCenter()
  },
  async mainCalendar() {
    return await mainCalendar()
  },
  // async rvitEvent(slug) {
  //   const rp = await rvitpage(slug, 'events')
  //   return rp
  // },
  // async rvitProgram(slug) {
  //   const rp = await rvitpage(slug, 'programs')
  //   return rp
  // },
  // async rvitGovernment(slug) {
  //   const rp = await rvitpage(slug, 'government')
  //   return rp
  // },
  // async rvitProgramDirectory(slug) {
  //   const rp = await rvitpage(slug, 'program-directory')
  //   return rp
  // },

  //agendas
  async agendas({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateAgendas(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalAgendas() {
    return await totalAgendas()
  },
  async agendasPage() {
    return await agendasPage()
  },


  //minutes
  async minutes({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateMinutes(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalMinutes() {
    return await totalMinutes()
  },
  async minutesPage() {
    return await minutesPage()
  },

  //news
  async news({ page, numberPerPage, sortField, sortCast, sortDirection }) {
    return await paginateNews(sortField, sortCast, sortDirection, page, numberPerPage)
  },
  async totalNews() {
    return await totalNews()
  },
  async newsPage() {
    return await newsPage()
  },
  async newsStory(urlSlug) {
    return await newsStory(urlSlug)
  },
}

